module.exports = __webpack_public_path__ + "media/src/fonts/icomoon-188c926c5bcb359f5ef478c64c6ba5f7.svg";